import { render, staticRenderFns } from "./kindChooseViewsPicSeventh.vue?vue&type=template&id=fcda0cbc&scoped=true"
import script from "./kindChooseViewsPicSeventh.vue?vue&type=script&lang=js"
export * from "./kindChooseViewsPicSeventh.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewsPicSeventh.vue?vue&type=style&index=0&id=fcda0cbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcda0cbc",
  null
  
)

export default component.exports